import { createModalStore } from '@/shared/lib/modal';
import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

type TrialPricingModalData = {
  openedAutomatically: boolean;
  pricingEntryPoint?: PricingEntryPoint;
};

export const useTrialPricingModalStore = createModalStore<TrialPricingModalData>(
  { openedAutomatically: false, pricingEntryPoint: 'unattributed_paywall' },
  false,
);
